export function requiredElement<T extends Element>(id: string): T {
	return requiredChild<T>(document, `#${CSS.escape(id)}`);
}

export function requiredChild<T extends Element>(
	root: ParentNode,
	selector: string,
): T {
	const element = root.querySelector<T>(selector);
	if (!element) {
		throw new Error(`Missing ${selector}`);
	}
	return element;
}
